import { useEffect, useState } from "react";
import styles from "./RegistrationName.module.css";

export function RegistrationName(props) {
  const [frontCount, setFrontCount] = useState(4);
  const [maxLength, setMaxLength] = useState(8);
  const [maxLengthSecond, setMaxLengthSecond] = useState(3);
  const [maxLengthFirst, setMaxLengthFirst] = useState(6);
  const normalize = (v) => (v || "").toUpperCase().replace(/\s+/g, " ").trim();

  const startsWithJersey = (value = "") =>
    props.choosedOptions.categoryPlate.includes("standard") &&
    value.toUpperCase().startsWith("J");

  const isAllowedJerseyTyping = (value = "") =>
    /^(?:J\d*|JSY\d*|JS)$/.test(value.toUpperCase());

  const joinRegistrationLines = (first = "", second = "") =>
    first + (second && !startsWithJersey(first) ? " " : "") + second;

 const handleJerseyInput = (value, pos) => {
  if (!props.choosedOptions.categoryPlate.includes("standard")) {
    return false;
  }

  const first = (
    props.choosedOptions.registrationNameFirst ?? ""
  ).toUpperCase();

  const second = (
    props.choosedOptions.registrationNameSecond ?? ""
  ).toUpperCase();

  const upperValue = value.toUpperCase();

  const registrationName =
    pos === "front"
      ? upperValue + second
      : pos === "second"
        ? first + upperValue
        : upperValue;

  if (registrationName.length === 0) {
    props.updateChoosedOptions({
      detectPlateFormat: "standard",
    });

    props.updateRegisterName({
      registrationName: "",
      registrationNameFirst: "",
      registrationNameSecond: "",
    });

    return true;
  }

  if (!startsWithJersey(registrationName)) {
    return false;
  }

  // if (
  //   props.choosedOptions.withoutValidation === "false" &&
  //   !isAllowedJerseyTyping(registrationName)
  // ) {
  //   props.onClick({
  //     isValid: false,
  //     typePlate: "typeStandard",
  //   });

  //   return true;
  // }

  if (props.choosedOptions.detectPlateFormat !== "jersey") {
    props.updateChoosedOptions({
      detectPlateFormat: "jersey",
    });
  }

  props.updateRegisterName({
    registrationName,
    registrationNameFirst:
      pos === "second" ? first : upperValue,
    registrationNameSecond:
      pos === "front"
        ? second
        : pos === "second"
          ? upperValue
          : "",
  });

  return true;
};

  const handleShowInput = (value, pos) => {
    if (!props.choosedOptions.categoryPlate.includes("show")) return false;

    if (!/^[A-Za-z0-9\s]*$/.test(value)) {
    props.onClick({
      isValid: false,
      typePlate: "typeShow",
    });

    return true;
  }
    const upperValue = value.toUpperCase();
    let first = props.choosedOptions.registrationNameFirst ?? "";
    let second = props.choosedOptions.registrationNameSecond ?? "";
    let registrationName;

    if (pos === "front") {
      first = upperValue;
      registrationName = first + (second.length > 0 ? " " : "") + second;
    } else if (pos === "second") {
      second = upperValue;
      registrationName = first + (second.length > 0 ? " " : "") + second;
    } else {
      registrationName = upperValue;
      const spaceIndex = upperValue.indexOf(" ");
      first = spaceIndex >= 0 ? upperValue.slice(0, spaceIndex) : upperValue;
      second = spaceIndex >= 0 ? upperValue.slice(spaceIndex + 1) : "";
    }

    props.updateRegisterName({
      registrationName,
      registrationNameFirst: first,
      registrationNameSecond: second,
    });
    return true;
  };

  function isValidTyping(value) {
    const v = value.toUpperCase();

    let stage = "letters";
    let lettersCount = 0;
    let numbersCount = 0;
    let suffixCount = 0;
    let spaceUsed = false;
    if (/^[A-Z]\d $/.test(v.slice(0, 3))) {
      return false;
    }
    if (/^[A-Z][A-Z]\d $/.test(v.slice(0, 4))) {
      return false;
    }
    for (let i = 0; i < v.length; i++) {
      const char = v[i];
      if (i === 0 && !/[A-Z]/.test(char)) return false;

      if (!/[A-Z0-9 ]/.test(char)) return false;

      if (stage === "letters") {
        if (/[A-Z]/.test(char)) {
          lettersCount++;
          if (lettersCount > 2) return false;
        } else if (/[0-9]/.test(char)) {
          stage = "numbers";
          numbersCount++;
        } else if (char === " ") {
          return false;
        }
      } else if (stage === "numbers") {
        if (/[0-9]/.test(char)) {
          numbersCount++;
          if (numbersCount > 2) return false;
        } else if (char === " ") {
          stage = "suffix";
          spaceUsed = true;
        } else {
          return false;
        }
      } else if (stage === "suffix") {
        if (/[A-Z]/.test(char)) {
          suffixCount++;
          if (suffixCount > 3) return false;
        } else {
          return false;
        }
      }
    }

    return true;
  }

  function detectFormat(value) {
    const v = value;
    if (v.startsWith(" ")) {
      return "invalidFirstLetter";
    }
    if (v.length === 0) {
      props.updateChoosedOptions({
        detectPlateFormat: "standard",
      });
      return "standard";
    }

    if (v.toUpperCase().startsWith("JSY") || v.toUpperCase().startsWith("J")) {
      return "jersey";
    }

    if (isValidTyping(v)) {
      props.updateChoosedOptions({
        detectPlateFormat: "standard",
      });
      return "standard";
    }
    if (/^[A-Z0-9]* ?[A-Z0-9]*$/.test(v)) {
      return "flexible";
    }

    if (/[^A-Z0-9 ]/.test(v)) {
      return "invalid";
    }

    return "invalid";
  }

  useEffect(() => {
    const {
      registrationNameFirst = "",
      registrationNameSecond = "",
      categoryPlate,
      detectPlateFormat,
    } = props.choosedOptions;

    const registrationName = (
      registrationNameFirst + " " + registrationNameSecond
    ).trim();

    const isJSY = registrationName.toUpperCase().startsWith("JSY");

    let totalLength = 7;

    if (categoryPlate === "show") {
      totalLength = 13;
    } else if (detectPlateFormat === "jersey") {
      totalLength = isJSY ? 9 : 7;
    } else if (detectPlateFormat === "flexible") {
      totalLength = 6;
    }

    const allowedTotal =
      detectPlateFormat === "flexible"
        ? totalLength + 1
        : totalLength;

    setMaxLengthFirst(
      Math.max(0, allowedTotal - registrationNameSecond.length),
    );

    setMaxLengthSecond(
      Math.max(0, allowedTotal - registrationNameFirst.length),
    );

    if (props.choosedOptions.categoryPlate.includes("standard")) {
      const value = props.choosedOptions.registrationName;

      if (!value) {
  if (props.choosedOptions.detectPlateFormat === "jersey") {
    props.updateChoosedOptions({
      detectPlateFormat: "standard",
    });

    props.updateRegisterName({
      registrationName: "",
      registrationNameFirst: "",
      registrationNameSecond: "",
    });
  }

  return;
}

      const format = detectFormat(value);

      if (
        format === "invalidFirstLetter" &&
        value.length > 1 &&
        props.choosedOptions.withoutValidation === "false"
      ) {
        props.onClick({
          isValid: false,
          typePlate: "typeStandard",
        });
        return;
      }

      if (
        format === "invalid" &&
        value.length > 1 &&
        props.choosedOptions.withoutValidation === "false"
      ) {
        props.onClick({
          isValid: false,
          typePlate: "typeStandard",
        });
        return;
      }

      if (format === "jersey") {
        if (props.choosedOptions.detectPlateFormat !== "jersey") {
          props.updateChoosedOptions({
            detectPlateFormat: "jersey",
          });
        }
        setMaxLength(value.toUpperCase().startsWith("JSY") ? 9 : 7);

        // if (
        //   props.choosedOptions.withoutValidation === "false" &&
        //   !isAllowedJerseyTyping(value)
        // ) {
        //   props.onClick({
        //     isValid: false,
        //     typePlate: "typeStandard",
        //   });
        // }
        return;
      }

      if (format === "flexible") {
        props.updateChoosedOptions({
          detectPlateFormat: "flexible",
        });
        return;
      }
    } else if (
      props.choosedOptions.categoryPlate.includes("show") &&
      /[$&+,:;=?@#|'<>.^*()%!-]/g.test(props.choosedOptions.registrationName)
    ) {
      let regValidShow = !/[$&+,:;=?@#|'<>.^*()%!-]/g.test(
        props.choosedOptions.registrationName,
      );
      if (regValidShow) {
        props.onClick({
          isValid: regValidShow,
          typePlate: "show",
        });
      }
    }

    if (
      props.choosedOptions.categoryPlate.includes("standard") &&
      props.choosedOptions.detectPlateFormat === "flexible" &&
      props.choosedOptions.withoutValidation === "false" &&
      props.choosedOptions.registrationName.length === 8 &&
      (!/[A-Za-z]/.test(props.choosedOptions.registrationName) ||
        !/\d/.test(props.choosedOptions.registrationName) ||
        !props.choosedOptions.registrationName.includes(" "))
    ) {
      props.onClick({
        isValid: false,
        typePlate: "typeStandard",
      });
    }

    if (
      /^[0-9]*$/.test(props.choosedOptions.registrationName.slice(1, 3)) &&
      props.choosedOptions.registrationName.length > 1
    ) {
      setMaxLength(8);
    } else {
      setMaxLength(8);
    }
    if (
      /^JSY\d*$/.test(props.choosedOptions.registrationName.slice(0, 3)) &&
      props.choosedOptions.registrationName.length > 1
    ) {
      setMaxLength(9);
    }

    if (
      /^J\d*$/.test(props.choosedOptions.registrationName) &&
      props.choosedOptions.registrationName.length > 1
    ) {
      setMaxLength(7);
    }
  }, [props.choosedOptions.registrationName]);

  useEffect(() => {
    if (props.choosedOptions.breakLine === "true") {
      if (startsWithJersey(props.choosedOptions.registrationNameFirst)) {
        const registrationName = joinRegistrationLines(
          props.choosedOptions.registrationNameFirst,
          props.choosedOptions.registrationNameSecond,
        );
        if (registrationName !== props.choosedOptions.registrationName) {
          props.updateRegisterName({ registrationName });
        }
      } else {
        props.choosedOptions.registrationNameSecond.length > 0
          ? props.updateRegisterName({
              registrationName:
                props.choosedOptions.registrationNameFirst +
                (
                  !startsWithJersey(
                    props.choosedOptions.registrationNameFirst,
                  )
                    ? " "
                    : ""
                ) +
                props.choosedOptions.registrationNameSecond,
            })
          : props.updateRegisterName({
              registrationName: props.choosedOptions.registrationNameFirst,
            });
      }
    }
  }, [props.choosedOptions.breakLine]);

  useEffect(() => {
    if (props.choosedOptions.categoryPlate.includes("standard")) {
      let name = props.choosedOptions.registrationName.slice(0, maxLength);

      if (/^J\d*$/.test(props.choosedOptions.registrationName.slice(0, 3))) {
        name = props.choosedOptions.registrationName.slice(0, 7);
      }

      if (/^JSY\d*$/.test(props.choosedOptions.registrationName.slice(0, 3))) {
        name = props.choosedOptions.registrationName.slice(0, 9);
      }

      const [first, second] = name.split(" ");
      props.updateRegisterName({
        registrationName: name,
        registrationNameFirst: first,
        registrationNameSecond: second ?? "",
      });
    }

    const isJersey =
      (/^J\d*$/.test(props.choosedOptions.registrationName) &&
        props.choosedOptions.registrationName.length > 3) ||
      (/^JSY\d*$/.test(props.choosedOptions.registrationName) &&
        props.choosedOptions.registrationName.length > 2);

    const isFlexible = /^[A-Z0-9]* ?[A-Z0-9]*$/.test(
      props.choosedOptions.registrationName,
    );

    if (
      isJersey &&
      props.choosedOptions.categoryPlate.includes("standard")
    ) {
      let registrationName =
        props.choosedOptions.registrationName
          .replace(/\s+/g, "")
          .slice(0, 9);

      if (!/^JSY\d*$/.test(registrationName)) {
        registrationName = registrationName.slice(0, 7);
      }

      props.updateChoosedOptions({
        registrationName,
        registrationNameFirst: registrationName.slice(0, -3),
        registrationNameSecond: registrationName.slice(-3),
      });
      return;
    }

    if (isFlexible && props.choosedOptions.registrationName.length > 0) {
      const [first, second] =
        props.choosedOptions.registrationName.split(" ");

      props.updateRegisterName({
        registrationNameFirst: first,
        registrationNameSecond: second ?? "",
      });

      return;
    }

    if (
      !props.choosedOptions.registrationNameFirst &&
      !props.choosedOptions.registrationNameSecond
    ) {
      if (
        props.choosedOptions.categoryPlate.includes("standard") &&
        !props.choosedOptions.detectPlateFormat.includes("jersey") &&
        !props.choosedOptions.detectPlateFormat.includes("flexible")
      ) {
        if (
          /^[0-9]*$/.test(
            props.choosedOptions.registrationName.slice(1, 3),
          )
        ) {
          props.updateRegisterName({
            registrationName: props.choosedOptions.registrationName
              .replace(/\s/g, "")
              .replace(/[^a-zA-Z0-9]/gi, "")
              .replace(/(.{3})/g, "$1 ")
              .trim()
              .toUpperCase(),
          });
        } else {
          props.updateRegisterName({
            registrationName: props.choosedOptions.registrationName
              .replace(/\s/g, "")
              .replace(/[^a-zA-Z0-9]/gi, "")
              .replace(/(.{4})/g, "$1 ")
              .trim()
              .toUpperCase(),
          });
        }
      }

      if (props.choosedOptions.registrationName.length > 0) {
        if (
          /^[0-9]*$/.test(
            props.choosedOptions.registrationName.slice(1, 3),
          )
        ) {
          props.updateRegisterName({
            registrationNameFirst:
              props.choosedOptions.registrationName.slice(0, 3),
            registrationNameSecond:
              props.choosedOptions.registrationName
                .slice(3)
                .trim(),
          });
        } else {
          props.updateRegisterName({
            registrationNameFirst:
              props.choosedOptions.registrationName.slice(0, 4),
            registrationNameSecond:
              props.choosedOptions.registrationName
                .slice(4)
                .trim(),
          });
        }
      }
    }
  }, []);

  const changeInputStyle = (e, pos) => {
    if (handleShowInput(e.target.value, pos)) return;
    if (handleJerseyInput(e.target.value, pos)) return;

    let filterInputValue;
    const rawValue = e.target.value;
    const upperValue = rawValue.toUpperCase();

    let isJersey =
      !isValidTyping(e.target.value) &&
      (/^J\d*$/.test(upperValue) || /^JSY\d*$/.test(upperValue));

    let isFlexible =
      !isValidTyping(e.target.value) &&
      /^[A-Za-z0-9]* ?[A-Za-z0-9]*$/.test(upperValue);

    if (pos === "front") {
      isJersey =
        !isValidTyping(
          e.target.value + " " + props.choosedOptions.registrationNameSecond,
        ) &&
        (/^J\d*$/.test(
          upperValue + props.choosedOptions.registrationNameSecond,
        ) ||
          /^JSY\d*$/.test(
            upperValue + props.choosedOptions.registrationNameSecond,
          ));

      isFlexible =
        !isValidTyping(
          e.target.value + " " + props.choosedOptions.registrationNameSecond,
        ) &&
        /^[A-Za-z0-9]* ?[A-Za-z0-9]*$/.test(
          upperValue + " " + props.choosedOptions.registrationNameSecond,
        );
    }

    if (pos === "second") {
      isJersey =
        !isValidTyping(
          props.choosedOptions.registrationNameFirst + " " + e.target.value,
        ) &&
        (/^J\d*$/.test(
          props.choosedOptions.registrationNameFirst + " " + upperValue,
        ) ||
          /^JSY\d*$/.test(
            props.choosedOptions.registrationNameFirst + " " + upperValue,
          ));

      isFlexible =
        !isValidTyping(
          props.choosedOptions.registrationNameFirst + " " + e.target.value,
        ) &&
        /^[A-Za-z0-9]* ?[A-Za-z0-9]*$/.test(
          props.choosedOptions.registrationNameFirst + " " + e.target.value,
        );
    }

    if (
      isJersey &&
      isFlexible &&
      !props.choosedOptions.detectPlateFormat.includes("standard")
    ) {
      props.updateChoosedOptions({
        detectPlateFormat: "jersey",
      });
    }

    if (
      props.choosedOptions.withoutValidation === "false" &&
      props.choosedOptions.categoryPlate.includes("standard") &&
      (props.choosedOptions.detectPlateFormat.includes("jersey") ||
        props.choosedOptions.detectPlateFormat.includes("flexible"))
    ) {
      filterInputValue = e.target.value.toUpperCase();

      if (pos === "second") {
        if (e.target.value.includes(" ")) {
          return;
        }

        if (
          (props.choosedOptions.detectPlateFormat.includes("jersey") &&
            !/^[0-9]*$/.test(e.target.value)) ||
          (props.choosedOptions.detectPlateFormat.includes("flexible") &&
            !/^[A-Za-z0-9]+$/.test(e.target.value))
        ) {
          if (/^[A-Za-z]{0,3}$/.test(e.target.value)) {
            props.updateChoosedOptions({
              detectPlateFormat: "standard",
            });

            if (
              maskOnInput(
                e.target.value.length,
                e.target.value,
                "all",
                "standard",
              )
            ) {
              if (/^[0-9]*$/.test(e.target.value.slice(1, 3))) {
                filterInputValue = e.target.value
                  .replace(/[^a-zA-Z0-9]/gi, "")
                  .replace(/(.{3})/g, "$1 ")
                  .trim()
                  .toUpperCase();
              } else {
                filterInputValue = e.target.value
                  .replace(/[^a-zA-Z0-9]/gi, "")
                  .replace(/(.{4})/g, "$1 ")
                  .trim()
                  .toUpperCase();
              }
            }
          } else if (isFlexible) {
            props.updateChoosedOptions({
              detectPlateFormat: "flexible",
            });
          } else {
            if (e.target.value.includes(" ")) {
              filterInputValue = value.trim().replace(/\s+/g, " ");
            } else {
              filterInputValue = e.target.value.slice(0, -1);
            }

            props.onClick({
              isValid: false,
              typePlate: "typeStandard",
            });
          }

          if (isFlexible) {
            props.updateRegisterName({
              registrationName:
                props.choosedOptions.registrationNameFirst +
                " " +
                filterInputValue?.trim(),
              registrationNameFirst:
                props.choosedOptions.registrationNameFirst,
              registrationNameSecond:
                filterInputValue?.trim() ?? "",
            });
          } else {
            props.updateRegisterName({
              registrationName:
                props.choosedOptions.registrationName.slice(0, -1),
              registrationNameFirst:
                props.choosedOptions.registrationNameFirst,
              registrationNameSecond:
                filterInputValue?.trim() ?? "",
            });
          }

          return;
        } else {
          filterInputValue = e.target.value.toUpperCase();

          props.updateRegisterName({
            registrationName:
              props.choosedOptions.registrationNameFirst +
              " " +
              filterInputValue,
            registrationNameFirst:
              props.choosedOptions.registrationNameFirst,
            registrationNameSecond:
              filterInputValue?.trim() ?? "",
          });
          return;
        }
      } else if (
        pos === "front" &&
        props.choosedOptions.detectPlateFormat.includes("flexible")
      ) {
        if (e.target.value.includes(" ")) {
          return;
        }

        if (!/^[A-Za-z0-9]+$/.test(e.target.value)) {
          if (/^[A-Za-z]{1,2}[0-9]{0,2}$/.test(e.target.value)) {
            props.updateChoosedOptions({
              detectPlateFormat: "standard",
            });

            if (
              maskOnInput(
                e.target.value.length,
                e.target.value,
                "all",
                "standard",
              )
            ) {
              if (/^[0-9]*$/.test(e.target.value.slice(1, 3))) {
                filterInputValue = e.target.value
                  .replace(/[^a-zA-Z0-9]/gi, "")
                  .replace(/(.{3})/g, "$1 ")
                  .trim()
                  .toUpperCase();
              } else {
                filterInputValue = e.target.value
                  .replace(/[^a-zA-Z0-9]/gi, "")
                  .replace(/(.{4})/g, "$1 ")
                  .trim()
                  .toUpperCase();
              }
            }
          } else {
            if (e.target.value.includes(" ")) {
              filterInputValue = value.trim().replace(/\s+/g, " ");
            } else {
              filterInputValue = e.target.value.slice(0, -1);
            }

            props.onClick({
              isValid: false,
              typePlate: "typeStandard",
            });
          }

          props.updateRegisterName({
            registrationName: filterInputValue,
            registrationNameFirst:
              filterInputValue +
              " " +
              props.choosedOptions.registrationNameSecond,
            registrationNameSecond:
              props.choosedOptions.registrationNameSecond,
          });
          return;
        } else {
          filterInputValue = e.target.value.toUpperCase();

          props.updateRegisterName({
            registrationName:
              filterInputValue +
              props.choosedOptions.registrationNameSecond,
            registrationNameFirst:
              filterInputValue?.trim() ?? "",
            registrationNameSecond:
              props.choosedOptions.registrationNameSecond,
          });
          return;
        }
      } else if (
        pos === "front" &&
        props.choosedOptions.detectPlateFormat.includes("jersey")
      ) {
        if (e.target.value.includes(" ")) {
          return;
        }

        if (
          !/^J\d*$/.test(e.target.value) &&
          !/^JSY\d*$/.test(e.target.value)
        ) {
          if (/^[A-Za-z]{1,2}[0-9]{0,2}$/.test(e.target.value)) {
            props.updateChoosedOptions({
              detectPlateFormat: "standard",
            });

            if (
              maskOnInput(
                e.target.value.length,
                e.target.value,
                "all",
                "standard",
              )
            ) {
              if (/^[0-9]*$/.test(e.target.value.slice(1, 3))) {
                filterInputValue = e.target.value
                  .replace(/[^a-zA-Z0-9]/gi, "")
                  .replace(/(.{3})/g, "$1 ")
                  .trim()
                  .toUpperCase();
              } else {
                filterInputValue = e.target.value
                  .replace(/[^a-zA-Z0-9]/gi, "")
                  .replace(/(.{4})/g, "$1 ")
                  .trim()
                  .toUpperCase();
              }
            }
          } else if (isFlexible) {
            props.updateChoosedOptions({
              detectPlateFormat: "flexible",
            });
          } else {
            if (e.target.value.includes(" ")) {
              filterInputValue = value.trim().replace(/\s+/g, " ");
            } else {
              filterInputValue = e.target.value.slice(0, -1);
            }

            props.onClick({
              isValid: false,
              typePlate: "typeStandard",
            });
          }

          props.updateRegisterName({
            registrationName:
              filterInputValue.trim() +
              props.choosedOptions.registrationNameSecond,
            registrationNameFirst: filterInputValue.trim(),
            registrationNameSecond:
              props.choosedOptions.registrationNameSecond,
          });
          return;
        } else {
          filterInputValue = e.target.value.toUpperCase();

          props.updateRegisterName({
            registrationName:
              filterInputValue +
              props.choosedOptions.registrationNameSecond,
            registrationNameFirst:
              filterInputValue?.trim() ?? "",
            registrationNameSecond:
              props.choosedOptions.registrationNameSecond,
          });
          return;
        }
      } else if (
        props.choosedOptions.detectPlateFormat === "jersey" &&
        (!/^J\d*$/.test(e.target.value) ||
          !/^JSY\d*$/.test(e.target.value))
      ) {
        props.onClick({
          isValid: false,
          typePlate: "typeStandard",
        });

        props.updateRegisterName({
          registrationName: filterInputValue.slice(0, -1),
        });
        return;
      } else if (
        (e.target.value.length > 3 &&
          props.choosedOptions.detectPlateFormat === "jersey" &&
          !/^J\d*$/.test(e.target.value) &&
          !/^JSY\d*$/.test(e.target.value)) ||
        (props.choosedOptions.detectPlateFormat === "flexible" &&
          !isFlexible)
      ) {
        if (
          /^[A-Za-z]{1,2}[0-9]{0,2} ?[A-Za-z]{0,3}$/.test(
            e.target.value,
          )
        ) {
          props.updateChoosedOptions({
            detectPlateFormat: "standard",
          });

          if (
            maskOnInput(
              e.target.value.length,
              e.target.value,
              "all",
              "standard",
            )
          ) {
            if (/^[0-9]*$/.test(e.target.value.slice(1, 3))) {
              filterInputValue = e.target.value
                .replace(/[^a-zA-Z0-9]/gi, "")
                .replace(/(.{3})/g, "$1 ")
                .trim()
                .toUpperCase();
            } else {
              filterInputValue = e.target.value
                .replace(/[^a-zA-Z0-9]/gi, "")
                .replace(/(.{4})/g, "$1 ")
                .trim()
                .toUpperCase();
            }
          }
        } else if (isFlexible) {
          props.updateChoosedOptions({
            detectPlateFormat: "flexible",
          });
        } else {
          filterInputValue = e.target.value.slice(0, -1);

          if (filterInputValue.length > 0) {
            props.onClick({
              isValid: false,
              typePlate: "typeStandard",
            });
          }
        }

        props.updateRegisterName({
          registrationName: filterInputValue,
          registrationNameFirst:
            filterInputValue.slice(0, 4).trim(),
          registrationNameSecond:
            filterInputValue.slice(4).trim(),
        });
        return;
      } else if (
        (props.choosedOptions.detectPlateFormat === "jersey" &&
          /^J\d*$/.test(e.target.value)) ||
        /^JSY\d*$/.test(e.target.value) ||
        (props.choosedOptions.detectPlateFormat === "flexible" &&
          isFlexible)
      ) {
        filterInputValue = e.target.value.toUpperCase();
        const [first = "", second = ""] =
          filterInputValue.split(" ");

        props.updateRegisterName({
          registrationName: filterInputValue,
          registrationNameFirst: first.trim(),
          registrationNameSecond: second.trim(),
        });
        return;
      }

      filterInputValue = e.target.value.toUpperCase();
      const [first = "", second = ""] =
        filterInputValue.split(" ");

      props.updateRegisterName({
        registrationName: filterInputValue,
        registrationNameFirst: first.trim(),
        registrationNameSecond: second.trim(),
      });
      return;
    }

    if (pos === "front") {
      if (
        props.choosedOptions.withoutValidation === "false" &&
        props.choosedOptions.categoryPlate.includes("standard") &&
        !isJersey &&
        !isFlexible
      ) {
        if (e.target.value.includes(" ")) {
          return;
        }

        if (
          maskOnInput(
            e.target.value.length,
            e.target.value,
            pos,
            "standard",
          )
        ) {
          filterInputValue = e.target.value
            .replace(/[^a-zA-Z0-9]/gi, "")
            .replace(/(.{4})/g, "$1 ")
            .trim()
            .toUpperCase();
        } else {
          filterInputValue = e.target.value.slice(0, -1);

          props.onClick({
            isValid: false,
            typePlate: "typeStandard",
          });
        }

        props.choosedOptions.registrationNameSecond.length > 0
          ? props.updateRegisterName({
              registrationNameFirst: filterInputValue.trim(),
              registrationName:
                filterInputValue +
                (props.choosedOptions.detectPlateFormat.includes("jersey")
                  ? ""
                  : " ") +
                props.choosedOptions.registrationNameSecond,
            })
          : props.updateRegisterName({
              registrationNameFirst: filterInputValue.trim(),
              registrationName: filterInputValue,
            });
      } else {
        if (
          maskOnInput(
            e.target.value.length,
            e.target.value,
            pos,
            "show",
          )
        ) {
          filterInputValue = e.target.value.toUpperCase();
        } else {
          filterInputValue = e.target.value.slice(0, -1);

          props.onClick({
            isValid: false,
            typePlate: "typeShow",
          });
        }

        props.choosedOptions.registrationNameSecond.length > 0
          ? props.updateRegisterName({
              registrationNameFirst: filterInputValue.trim(),
              registrationName:
                filterInputValue +
                (props.choosedOptions.detectPlateFormat.includes("jersey")
                  ? ""
                  : " ") +
                props.choosedOptions.registrationNameSecond,
            })
          : props.updateRegisterName({
              registrationNameFirst: filterInputValue.trim(),
              registrationName: filterInputValue,
            });
      }
    } else if (pos === "second") {
      if (
        props.choosedOptions.withoutValidation === "false" &&
        props.choosedOptions.categoryPlate.includes("standard") &&
        !isJersey &&
        !isFlexible
      ) {
        if (e.target.value.includes(" ")) {
          return;
        }

        if (
          maskOnInput(
            e.target.value.length,
            e.target.value,
            pos,
            "standard",
          )
        ) {
          filterInputValue = e.target.value
            .replace(/[^a-zA-Z0-9]/gi, "")
            .replace(/(.{4})/g, "$1 ")
            .trim()
            .toUpperCase();
        } else {
          filterInputValue = e.target.value.slice(0, -1);

          props.onClick({
            isValid: false,
            typePlate: "typeStandard",
          });
        }

        props.updateRegisterName({
          registrationNameSecond: filterInputValue,
          registrationName:
            props.choosedOptions.registrationNameFirst +
            " " +
            filterInputValue,
        });
      } else {
        if (
          maskOnInput(
            e.target.value.length,
            e.target.value,
            pos,
            "show",
          )
        ) {
          filterInputValue = e.target.value.toUpperCase();
        } else {
          filterInputValue = e.target.value.slice(0, -1);

          props.onClick({
            isValid: false,
            typePlate: "typeShow",
          });
        }

        props.updateRegisterName({
          registrationNameSecond: filterInputValue,
          registrationName:
            props.choosedOptions.registrationNameFirst +
            " " +
            filterInputValue,
        });
      }
    } else {
      if (
        props.choosedOptions.withoutValidation === "false" &&
        props.choosedOptions.categoryPlate.includes("standard") &&
        !isJersey &&
        !isFlexible
      ) {
        if (
          maskOnInput(
            e.target.value.length,
            e.target.value,
            "all",
            "standard",
          )
        ) {
          filterInputValue = e.target.value.toUpperCase();
        } else {
          filterInputValue = e.target.value.slice(0, -1);

          if (e.target.value.length > 0) {
            props.onClick({
              isValid: false,
              typePlate: "typeStandard",
            });
          }
        }

        props.updateRegisterName({
          registrationName: filterInputValue,
          registrationNameFirst:
            filterInputValue.slice(0, frontCount).trim(),
          registrationNameSecond:
            filterInputValue.slice(frontCount).trim(),
        });
      } else {
        if (
          maskOnInput(
            e.target.value.length,
            e.target.value,
            pos,
            "show",
          )
        ) {
          filterInputValue = e.target.value.toUpperCase();
        } else {
          filterInputValue = e.target.value.slice(0, -1);

          props.onClick({
            isValid: false,
            typePlate: "typeShow",
          });
        }

        if (props.choosedOptions.detectPlateFormat.includes("jersey")) {
          props.updateRegisterName({
            registrationName: filterInputValue,
            registrationNameFirst: filterInputValue,
            registrationNameSecond: "",
          });
        }

        if (props.choosedOptions.detectPlateFormat.includes("flexible")) {
          const [first = "", second = ""] =
            filterInputValue.split(" ");

          props.updateRegisterName({
            registrationName: filterInputValue,
            registrationNameFirst: first.trim(),
            registrationNameSecond: second.trim(),
          });
        } else if (props.choosedOptions.registrationName.indexOf(" ")) {
          const arrNames =
            e.target.value.toUpperCase().split(" ");

          let firstName =
            arrNames.length > 0 ? arrNames[0] : "";

          let secondName =
            arrNames.length > 1 ? arrNames[1] : "";

          props.updateRegisterName({
            registrationName: filterInputValue,
            registrationNameFirst: firstName.trim(),
            registrationNameSecond: secondName,
          });
        } else {
          props.updateRegisterName({
            registrationName: filterInputValue,
            registrationNameFirst:
              filterInputValue.slice(0, 12).trim(),
            registrationNameSecond:
              filterInputValue.slice(12).trim(),
          });
        }
      }
    }
  };

  function maskOnInput(length, value, pos, category) {
    const upperValue = value.toUpperCase();
    const isFlexible = /^[A-Z0-9]* ?[A-Z0-9]*$/.test(upperValue);

    const isJersey =
      (/^J\d*$/.test(upperValue) && upperValue.length > 3) ||
      (/^JSY\d*$/.test(upperValue) && upperValue.length > 2);

    if (value.slice(0, 1) === " ") {
      return false;
    }

    if (category.includes("standard")) {
      if (pos === "second") {
        if (length > 0 && length < 4) {
          if (props.choosedOptions.detectPlateFormat.includes("jersey")) {
            return /^[0-9]*$/.test(value);
          } else if (
            !props.choosedOptions.detectPlateFormat.includes("flexible")
          ) {
            return /^[A-Za-z\s]*$/.test(value);
          }
        }
      } else {
        if (
          length >= 4 &&
          /^[0-9]*$/.test(value.slice(1, 3)) &&
          pos === "first"
        ) {
          setFrontCount(4);
        } else if (
          props.choosedOptions.registrationName.startsWith("JSY")
        ) {
          setFrontCount(4);
          return /^JSY\d*$/.test(value);
        } else if (
          length >= 2 &&
          /^[0-9]*$/.test(value.slice(1, 2))
        ) {
          setFrontCount(3);

          if (length > 0 && length < 2) {
            return /^[A-Za-z\s]*$/.test(value);
          } else if (length >= 1 && length < 4) {
            return /^[0-9]*$/.test(value.slice(1, 3));
          } else if (length >= 4 && length < 8) {
            return (
              /^[A-Za-z\s]*$/.test(value.slice(3, 7)) &&
              /^[0-9]*$/.test(value.slice(1, 3))
            );
          }
        } else {
          setFrontCount(4);

          if (length > 0 && length < 3) {
            return /^[A-Za-z\s]*$/.test(value);
          } else if (length >= 3 && length < 5) {
            return /^[0-9]*$/.test(value.slice(2, 4));
          } else if (length >= 5 && length < 9) {
            return (
              /^[A-Za-z\s]*$/.test(value.slice(4, 8)) &&
              /^[0-9]*$/.test(value.slice(2, 4))
            );
          }
        }
      }
    } else {
      return /^[A-Za-z0-9\s]*$/.test(value);
    }
  }

  function isValidRegisterName(event) {
    event ? event.preventDefault() : false;
  }

  const checkPasteValue = (e, count, pos) => {
    e.preventDefault();
    const pastedText =
      e.clipboardData.getData("text").toUpperCase();

    if (
      handleShowInput(
        pastedText,
        pos === "first" ? "front" : pos,
      )
    ) {
      return;
    }

    if (
      handleJerseyInput(
        pastedText,
        pos === "first" ? "front" : pos,
      )
    ) {
      return;
    }

    if (pastedText.length < count) {
      return false;
    } else {
      if (
        props.choosedOptions.categoryPlate.includes("standard") &&
        props.choosedOptions.detectPlateFormat.includes("standard")
      ) {
        if (pos === "first") {
          props.choosedOptions.registrationNameSecond.length > 0
            ? props.updateRegisterName({
                registrationNameFirst: pastedText.trim(),
                registrationName:
                  pastedText +
                  " " +
                  props.choosedOptions.registrationNameSecond,
              })
            : props.updateRegisterName({
                registrationNameFirst: pastedText.trim(),
                registrationName: pastedText,
              });
        } else if (pos === "second") {
          props.updateRegisterName({
            registrationNameSecond: pastedText,
            registrationName:
              props.choosedOptions.registrationNameFirst +
              " " +
              pastedText,
          });
        } else {
          if (
            /^[0-9]*$/.test(
              props.choosedOptions.registrationName.slice(1, 3),
            )
          ) {
            props.updateRegisterName({
              registrationName: pastedText,
              registrationNameFirst:
                pastedText.slice(0, 3).trim(),
              registrationNameSecond:
                pastedText.slice(3).trim(),
            });
          } else {
            props.updateRegisterName({
              registrationName: pastedText,
              registrationNameFirst:
                pastedText.slice(0, frontCount).trim(),
              registrationNameSecond:
                pastedText.slice(frontCount).trim(),
            });
          }
        }
      } else {
        if (pos === "first") {
          props.updateRegisterName({
            registrationNameFirst: pastedText.trim(),
            registrationName:
              pastedText +
              props.choosedOptions.registrationNameSecond,
          });
        } else if (pos === "second") {
          props.updateRegisterName({
            registrationNameSecond: pastedText,
            registrationName:
              props.choosedOptions.registrationNameFirst +
              pastedText,
          });
        } else {
          props.updateRegisterName({
            registrationName: pastedText,
            registrationNameFirst:
              pastedText.slice(0, 12).trim(),
            registrationNameSecond:
              pastedText.slice(12).trim(),
          });
        }
      }
    }
  };

  return (
    <>
      {props.choosedOptions.breakLine === "true" && (
        <>
          <form
            onSubmit={isValidRegisterName}
            className={styles["registration-name"] + " flex"}
          >
            <input
              onChange={(e) => changeInputStyle(e, "front")}
              className={styles["registration-name__input"]}
              type="text"
              maxLength={
                props.choosedOptions.categoryPlate.includes("show")
                  ? 12
                  : maxLengthFirst
              }
              value={props.choosedOptions.registrationNameFirst}
              placeholder="ENTER TOP LINE REG"
              onPaste={(e) =>
                checkPasteValue(e, frontCount, "first")
              }
              ref={props.inputRef}
              onBlur={() =>
                props.updateRegisterName({
                  registrationNameFirst:
                    props.choosedOptions.registrationNameFirst.trim(),
                  registrationName:
                    joinRegistrationLines(
                      props.choosedOptions.registrationNameFirst.trim(),
                      props.choosedOptions.registrationNameSecond,
                    ),
                })
              }
              onClick={() => props.isDefaultName(false)}
            />
            <button
              onClick={() => {
                props.addFocus();
              }}
              className={
                styles["registration-name__edit"] +
                " flex items-center"
              }
            >
              EDIT
            </button>
          </form>

          <form
            onSubmit={isValidRegisterName}
            className={styles["registration-name"] + " flex"}
          >
            <input
              onChange={(e) => changeInputStyle(e, "second")}
              className={styles["registration-name__input"]}
              type="text"
              maxLength={maxLengthSecond}
              value={props.choosedOptions.registrationNameSecond}
              placeholder="ENTER BOTTOM LINE REG"
              onPaste={(e) =>
                checkPasteValue(e, 3, "second")
              }
              onBlur={() =>
                props.updateRegisterName({
                  registrationNameSecond:
                    props.choosedOptions.registrationNameSecond.trim(),
                  registrationName:
                    joinRegistrationLines(
                      props.choosedOptions.registrationNameFirst,
                      props.choosedOptions.registrationNameSecond.trim(),
                    ),
                })
              }
              ref={props.inputRef}
              onClick={() => props.isDefaultName(false)}
            />
            <button
              onClick={() => {
                props.addFocus();
              }}
              className={
                styles["registration-name__edit"] +
                " flex items-center"
              }
            >
              EDIT
            </button>
          </form>
        </>
      )}

      {props.choosedOptions.breakLine === "false" && (
        <form
          onSubmit={isValidRegisterName}
          className={styles["registration-name"] + " flex"}
        >
          <input
            onClick={() => props.isDefaultName(false)}
            onChange={changeInputStyle}
            className={styles["registration-name__input"]}
            type="text"
            maxLength={
              props.choosedOptions.categoryPlate.includes("show")
                ? 25
                : maxLength
            }
            value={props.choosedOptions.registrationName}
            placeholder="ENTER YOUR REG"
            ref={props.inputRef}
            onPaste={(e) => checkPasteValue(e, 7)}
          />
          <button
            onClick={() => {
              props.addFocus();
            }}
            className={
              styles["registration-name__edit"] +
              " flex items-center"
            }
          >
            EDIT
          </button>
        </form>
      )}
    </>
  );
}